import AcademicCap from "assets/icons/AcademicCap";
import Clock from "assets/icons/Clock";
import Popularity from "assets/icons/PopularityIcon";
import Label from "components/common/Label";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import { t } from "i18next";

export default function TestCard({
  progress_precentage,
  title,
  duration,
  difficulty,
  popularity,
  profile_image,
  showProgress = false,
  onClick,
}) {
  const { language, dir } = useAppSelector(getSettings);
  return (
    <>
      <div
        className="max-w-[185px] min-w-[185px] md:max-w-[220px] w-full md:min-w-[220px] h-[364px] rounded-xl shadow-xl bg-white"
        dir={dir}
      >
        <div
          className="relative w-fll max-h-44 h-44 rounded-tr-xl rounded-tl-xl bg-no-repeat bg-cover bg-center"
          style={{
            backgroundImage: `url(${
              profile_image
                ? profile_image
                : require("assets/images/persona-ai/test-1.png")
            })`,
          }}
          onClick={onClick}
        >
          {showProgress ? (
            <div
              className={`absolute top-0 left-0 w-full h-full rounded-tr-xl rounded-tl-xl flex items-center justify-center bg-opacity-40 
          ${progress_precentage == 100 ? "bg-[#489900]" : "bg-[#111111]"}
          `}
            >
              <p className="text-white font-extralight text-3xl">
                {progress_precentage ?? 0}% {t("done")}
              </p>
            </div>
          ) : (
            ""
          )}
        </div>
        {showProgress ? (
          <div className="bg-[#BEBEBE] h-1 w-full">
            <div
              className={`h-full ${
                progress_precentage == 100 ? "bg-[#489900]" : "bg-[#F29423]"
              }`}
              style={{ width: `${progress_precentage}%` }}
            ></div>
          </div>
        ) : (
          ""
        )}
        <div className="px-2 py-4 md:p-4">
          <Label
            className="text-lg font-medium cursor-pointer hover:underline"
            onClick={onClick}
          >
            {title[language]}
          </Label>
          <div className="flex flex-col gap-1.5 mt-4">
            <div className="flex items-center gap-3">
              <Clock />
              <p className="text-[##1F1A20]">{duration} {t("quizTimeMinutes")}</p>
            </div>
            <div className="flex items-center gap-3">
              <AcademicCap />
              <p className="text-[##1F1A20]">{t(difficulty)}</p>
            </div>
            <div className="flex items-center gap-3">
              <Popularity />
              <p className="text-[##1F1A20]">{popularity}%</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
